var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 33,
    viewBox: "0 0 24 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4445 0.5C5.95558 0.5 0.888916 5.38889 0.888916 11.6111C0.888916 12.9889 1.42225 15.7444 2.31114 17.7444C5.20003 24.3667 11.5111 31.8778 11.7778 32.1889C11.9556 32.4111 12.1778 32.5 12.4445 32.5C12.7111 32.5 12.9334 32.3667 13.1111 32.1889C13.3778 31.8778 19.6889 24.3667 22.5778 17.7444C23.4667 15.7444 24 12.9889 24 11.6111C24 5.38889 18.9334 0.5 12.4445 0.5ZM20.9334 17.0333C18.7111 22.1444 14.1778 28.0556 12.4445 30.1889C10.7111 28.0556 6.1778 22.1444 3.95558 17.0333C3.15558 15.3 2.66669 12.8111 2.66669 11.6111C2.66669 6.36667 6.9778 2.27778 12.4445 2.27778C17.9111 2.27778 22.2222 6.36667 22.2222 11.6111C22.2222 12.8111 21.7334 15.3 20.9334 17.0333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4445 5.83337C9.02229 5.83337 6.22229 8.63337 6.22229 12.0556C6.22229 15.4778 9.02229 18.2778 12.4445 18.2778C15.8667 18.2778 18.6667 15.4778 18.6667 12.0556C18.6667 8.63337 15.8667 5.83337 12.4445 5.83337ZM12.4445 16.5C10.0001 16.5 8.00007 14.5 8.00007 12.0556C8.00007 9.61115 10.0001 7.61115 12.4445 7.61115C14.889 7.61115 16.889 9.61115 16.889 12.0556C16.889 14.5 14.889 16.5 12.4445 16.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.407a5a9c2c298bb6577a9abe47f4848d.svg";
export { ForwardRef as ReactComponent };